<template>
  <div class="backdrop-vehicle-row container-fluid" role="region" :class="[brand === 'mazda' ? 'mazda-styles' : '']" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="row">
      <div class="col-xs-12 text-center">
        <h1>Pick Your Vehicle</h1>
      </div>
    </div>
    <div class="row carousel-row">
      <div class="white-overlay"></div>
      <div class="col-xs-12">
        <div
          id="carousel-with-backdrop"
          class="carousel slide"
          data-ride="carousel"
          data-interval="false"
        >
          <ol class="carousel-indicators">
            <li data-target="#carousel-with-backdrop" :class="[index === 0 ? 'active': '']" :data-slide-to="index" v-for="(sedan, index) in images.sedans" :key="sedan.index">
              {{modelName(sedan.modelName)}}
            </li>
            <li data-target="#carousel-with-backdrop" :class="[(index === 0 && images.sedans.length === 0) ? 'active': '']" :data-slide-to="index + images.sedans.length" v-for="(suv, index) in images.suvs" :key="suv.index">
              {{modelName(suv.modelName)}}
            </li>
            <li data-target="#carousel-with-backdrop" :data-slide-to="index + images.sedans.length + images.suvs.length" v-for="(truck, index) in images.trucks" :key="truck.index">
              {{modelName(truck.modelName)}}
            </li>
          </ol>

          <div class="carousel-inner" role="listbox">
            <div class="item" :class="[index === 0 ? 'active': '']" v-for="(sedan, index) in images.sedans" :key="sedan.index">
              <img :alt="modelName(sedan.modelName)" :src="sedan.sideView">
              <div class="carousel-caption">
                <a class="btn" href="#">Explore New</a >
                <a class="btn" href="#">Explore Used</a>
              </div>
            </div>
            <div class="item" :class="[(index === 0 && images.sedans.length === 0) ? 'active': '']" v-for="(suv, index) in images.suvs" :key="suv.index">
              <img :alt="suv.modelName" :src="suv.sideView">
              <div class="carousel-caption">
                <a class="btn" href="#">Explore New</a >
                <a class="btn" href="#">Explore Used</a>
              </div>
            </div>
            <div class="item" v-for="truck in images.trucks" :key="truck.index">
              <img :alt="truck.modelName" :src="truck.sideView">
              <div class="carousel-caption">
                <a class="btn" href="#">Explore New</a >
                <a class="btn" href="#">Explore Used</a>
              </div>
            </div>
          </div>
          <a class="left carousel-control" href="#carousel-with-backdrop" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#carousel-with-backdrop" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  mounted() {
    (function() {
      
      var c = {
        init: function() {
          $('#carousel-with-backdrop').carousel({
            interval: false
            })
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  },
  methods: {
    modelName (model) {
      if (this.brand === 'cjdr') {
        return model.toString().substr(model.indexOf(" ") + 1);
      } else {
        return model;
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.backdrop-vehicle-row {
  font-size: 16px;
  padding: 30px 0;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}
.backdrop-vehicle-row h1 {
  font-weight: 400;
}
.backdrop-vehicle-row a.btn {
  color: #fff;
  background: var(--primary-dark);
  border-radius: 2px;
  font-size: 15px;
  padding: 10px 30px;
  margin: 20px;
  text-transform: uppercase;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  -o-transition: all .5s ease;
  transition: all .5s ease;
}
.backdrop-vehicle-row a.btn:hover {
  color: var(--primary-dark);
  background: #fff;
}
.backdrop-vehicle-row .carousel-control {
  background-image: none;
}
.backdrop-vehicle-row .carousel-row {
  background-image: url(../../static/images/background-road-landscape.jpeg);
  background-size: cover;
  background-position-y: 60%;
  position: relative;
}
.backdrop-vehicle-row .carousel-row > .col-xs-12 {
  padding: 0;
}
.backdrop-vehicle-row .white-overlay {
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 0) 60%,
    rgba(255, 255, 255, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 0) 60%,
    rgba(255, 255, 255, 1) 100%
  );
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 0) 60%,
    rgba(255, 255, 255, 1) 100%
  );
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: 0;
  right: 0;
}
.backdrop-vehicle-row img {
  margin: 45px auto auto;
  padding-bottom: 30px;
  max-height: 300px;
  min-height: 300px;
}
.backdrop-vehicle-row[data-brand="cjdr"] img {
  padding-bottom: 15px;
  padding-top: 15px;
}
.backdrop-vehicle-row .item {
  -webkit-transition: all .8s ease;
  -moz-transition: all .8s ease;
  -o-transition: all .8s ease;
  transition: all .8s ease;
  left: 0;
  right: 0;
  top: 0;
  float: none !important;
  padding-left: 15px;
  padding-right: 15px;
}
.backdrop-vehicle-row #carousel-with-backdrop {
  padding-top: 6%;
}
.backdrop-vehicle-row .carousel-indicators li {
  width: unset;
  height: unset;
  border-bottom: 2px solid transparent;
  border-top: none;
  border-right: none;
  border-left: none;
  border-radius: 0 !important;
  margin: 8px;
  text-indent: 0;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  -o-transition: all .5s ease;
  transition: all .5s ease;
}
.backdrop-vehicle-row.mazda-styles .carousel-indicators li {
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.backdrop-vehicle-row .carousel-indicators li.active {
  background: none;
  border-radius: 0 !important;
  border-bottom: 2px solid var(--primary-color);
  color: var(--primary-color);
}
.backdrop-vehicle-row .carousel-indicators li:hover {
  border-bottom: 2px solid var(--primary-color);
}
.backdrop-vehicle-row[data-brand="cjdr"] .carousel-indicators li:hover {
  border-bottom: 2px solid var(--secondary-color);
}
.backdrop-vehicle-row[data-brand="cjdr"] .carousel-indicators li.active {
  border-bottom: 2px solid var(--secondary-color);
  color: var(--secondary-color);
}
.backdrop-vehicle-row .carousel-indicators {
  top: 0 !important;
  bottom: unset;
  width: 94%;
  margin-left: -47%;
  z-index: 5;
}
.backdrop-vehicle-row .carousel-caption {
  position: relative;
  padding-top: 0;
  right: 0;
  left: 0;
}

@media (max-width: 1400px) {
  .backdrop-vehicle-row #carousel-with-backdrop {
    padding-top: 6%;
  }
}

@media (max-width: 991px) {
  .backdrop-vehicle-row #carousel-with-backdrop {
    padding-top: 10%;
  }

  .backdrop-vehicle-row img {
    height: auto;
  }
  .backdrop-vehicle-row[data-brand="cjdr"] img {
    padding-bottom: 0px;
    padding-top: 30px;
  }
}

@media (max-width: 767px) {
  .backdrop-vehicle-row ol.carousel-indicators {
    width: 100%;
    margin-left: -50%;
  }
  .backdrop-vehicle-row #carousel-with-backdrop {
    padding-top: 15%;
  }
  .backdrop-vehicle-row img {
    min-height: unset;
  }
  .backdrop-vehicle-row .carousel-caption {
    left: 0;
    right: 0;
  }
}

@media (max-width: 600px) {
  .backdrop-vehicle-row #carousel-with-backdrop {
    padding-top: 25%;
  }

  .backdrop-vehicle-row img {
    padding-bottom: 50px;
  }
}

@media (max-width: 427px) {
  .backdrop-vehicle-row #carousel-with-backdrop {
    padding-top: 45%;
  }
  .backdrop-vehicle-row a.btn {
    margin: 5px;
    padding: 10px 20px;
  }
  .backdrop-vehicle-row[data-brand="cjdr"] img {
    padding-top: 10px;
    padding-bottom: 30px;
  }
}
</style>
